import type { WhatsNewBody } from '../types';

export default {
  title: 'Meetings: agendas and minutes on the job',
  summary:
    'A new Meetings tab on each job, beside Documents. Draft an OAC meeting’s agenda (or any other meeting’s), then record the minutes against the same items once it has been held.',
  details: [
    'Each item has its minutes, a status (Open, Closed or Info only), who is responsible and when it is due.',
    'Pick attendees from the job’s team and Contacts tab, or type them in, and mark who was present.',
    'Each type of meeting is numbered on its own: OAC Meeting #1, #2, and so on.',
    'Everyone who can see the job can read its meetings.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'pm-meetings' },
} satisfies WhatsNewBody;
